import React from "react";
import { withRouter } from "react-router";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import Page from "./Containers/Page";
import { inject, observer } from "mobx-react";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";

const RateTag = (props) => {
	const canonical = () => {
		const {
			ApplicationModel: { siteConfig },
			match,
		} = props;
		let location = generateUrl(configRouters.RatesTags.route, {
			regionUrl: match.params.regionUrl,
			tagCode: match.params.tagCode,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	return (
		<>
			{canonical()}
			<Page />
		</>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(RateTag))));
